import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { i18n } from './plugins/i18n'
import VueCarousel from 'vue-carousel';
import Vue2TouchEvents from 'vue2-touch-events'
import VueJustifiedLayout from 'vue-justified-layout'
import VueMeta from 'vue-meta'
import VueLazyload from 'vue-lazyload'
import Hero from 'vue-hero-transition';
import axios from './axios.js'
require('vue-ionicons/ionicons.css')
import Vuesax from 'vuesax'

import 'vuesax/dist/vuesax.css' //Vuesax styles
Vue.use(Vuesax, {
  // options here
})
import settings from './settings'
let htmlElement = document.documentElement;
htmlElement.setAttribute('theme', 'dark')
Vue.prototype.$req = axios
Vue.prototype.$baseUrl = settings.baseUrl
Vue.prototype.$apiUrl = settings.apiUrl
Vue.config.ignoredElements = [/^ion-icon/];
Vue.use(Hero);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'dist/error.png',
  loading: 'dist/loading.gif',
  attempt: 1
})
require('vue-ionicons/ionicons.css')
import './styles/style.scss'
Vue.prototype.$dark = true;
Vue.config.ignoredElements = [/^ion-icon/];
Vue.config.productionTip = false
Vue.prototype.$darkMode = localStorage.getItem("theme") || true;
Vue.use(VueCarousel);
Vue.use(Vue2TouchEvents)
Vue.use(VueJustifiedLayout)
Vue.use(VueMeta)
let globalData = new Vue({
  data: {
    $sideBarType: 0,
    $darkmode: true,
    $rtl: false,
    $locale: localStorage.getItem("locale") || 'ar',
    $direction: "rtl",

  }
});
Vue.mixin({
  computed: {
    $sideBarType: {
      get: function () {
        return globalData.$data.$sideBarType
      },
      set: function (newVal) {
        globalData.$data.$sideBarType = newVal;
      }
    },
    $darkmode: {
      get: function () {
        return globalData.$data.$darkmode
      },
      set: function (newVal) {
        globalData.$data.$darkmode = newVal;
      }
    },
    $locale: {
      get: function () {
        return globalData.$data.$locale
      },
      set: function (newVal) {
        globalData.$data.$locale = newVal;
      }
    },
    $direction: {
      get: function () {
        return globalData.$data.$direction
      },
      set: function (newVal) {
        globalData.$data.$direction = newVal;
      }
    },
    $rtl: {
      get: function () {
        return globalData.$data.$rtl
      },
      set: function (newVal) {
        globalData.$data.$rtl = newVal;
      }
    },
  }
})
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  watch: {
    '$sideBarType'(to, from) {
      console.log(from);
      console.log(to);
    }
  }
}).$mount('#app')

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters['auth/isLoggedIn']) {
      next()
      return
    }
    router.push("/pages/login", () => {});
  } else {
    next()
  }
})